export enum DriverRequirementEnforcementLevel {
  Allow = "Allow",
  Warning = "Warning",
  Prevent = "Prevent"
}
